module.exports = __webpack_public_path__ + "7ef72dcbff7438d52ea7a3d2ee6c5a9b.jpeg";